import { LoginClient } from '../types'
import { GetLoginResponse } from '../types/LoginClient'
import { executeRecaptcha } from 'lib/utils'

export const postLogin = (base: LoginClient) => async (email: string, password: string) => {
  const token = await executeRecaptcha('login');
  return await base.requester.post<GetLoginResponse>('', { email, password }, { withCredentials: true, headers: { 'X-Proof': token } });
};
